import { FeatureFlagKey } from 'src/stores/featureFlag/useFeatureFlagStore';

const getFlagOverrideKey = (flagKey: FeatureFlagKey) => {
	return `flag_override_${flagKey}`;
};

const isWindowDefined = () => typeof window !== 'undefined';

export const setFlagOverride = (flagKey: FeatureFlagKey, value: boolean) => {
	if (isWindowDefined()) {
		window.localStorage?.setItem(getFlagOverrideKey(flagKey), value.toString());
	}
};

export const clearFlagOverride = (flagKey: FeatureFlagKey) => {
	if (isWindowDefined()) {
		window.localStorage?.removeItem(getFlagOverrideKey(flagKey));
	}
};

export const getFlagOverrideValue = (flagKey: FeatureFlagKey) => {
	if (!isWindowDefined()) return false;

	const localStorageValue = window.localStorage?.getItem(
		getFlagOverrideKey(flagKey)
	);

	if (localStorageValue === undefined || localStorageValue === null)
		return undefined;

	return localStorageValue === 'true';
};
